var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"batches-competence","route":"/reports/billing-batches-competence","file-name":"lotes-por-competencia.xlsx","period-label":"Período de fechamento do lote","columns":_vm.columns,"show-status":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }